import React from "react";
import { useLocation, Navigate } from "react-router-dom";

export const TOKEN_KEY = "@CANS-Token";

export const setToken = (value) => localStorage.setItem(TOKEN_KEY, value);

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setTokenUser = (value) =>
  localStorage.setItem(`${TOKEN_KEY}-User`, value);

export const getTokenUser = () => localStorage.getItem(`${TOKEN_KEY}-User`);

export const setTokenIdentifier = (value) =>
  localStorage.setItem(`${TOKEN_KEY}-Identifier`, value);

export const getTokenIdentifier = () =>
  localStorage.getItem(`${TOKEN_KEY}-Identifier`);

export const isAuthenticated = () => getToken() !== null;

export const Logout = () => {
  localStorage.clear();
};

export const RequireAuth = (props) => {
  const location = useLocation();

  return isAuthenticated() === true ? (
    <>{props.children}</>
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};
